"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfDocumentRequestEnquiryInputDto = instanceOfDocumentRequestEnquiryInputDto;
exports.DocumentRequestEnquiryInputDtoFromJSON = DocumentRequestEnquiryInputDtoFromJSON;
exports.DocumentRequestEnquiryInputDtoFromJSONTyped = DocumentRequestEnquiryInputDtoFromJSONTyped;
exports.DocumentRequestEnquiryInputDtoToJSON = DocumentRequestEnquiryInputDtoToJSON;
exports.DocumentRequestEnquiryInputDtoToJSONTyped = DocumentRequestEnquiryInputDtoToJSONTyped;
/**
 * Check if a given object implements the DocumentRequestEnquiryInputDto interface.
 */
function instanceOfDocumentRequestEnquiryInputDto(value) {
    if (!('email' in value) || value['email'] === undefined)
        return false;
    if (!('listingId' in value) || value['listingId'] === undefined)
        return false;
    if (!('propertyMediaIds' in value) || value['propertyMediaIds'] === undefined)
        return false;
    if (!('isBAndPInspectionRequired' in value) || value['isBAndPInspectionRequired'] === undefined)
        return false;
    return true;
}
function DocumentRequestEnquiryInputDtoFromJSON(json) {
    return DocumentRequestEnquiryInputDtoFromJSONTyped(json, false);
}
function DocumentRequestEnquiryInputDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'email': json['email'],
        'listingId': json['listingId'],
        'propertyMediaIds': json['propertyMediaIds'],
        'isBAndPInspectionRequired': json['isBAndPInspectionRequired'],
    };
}
function DocumentRequestEnquiryInputDtoToJSON(json) {
    return DocumentRequestEnquiryInputDtoToJSONTyped(json, false);
}
function DocumentRequestEnquiryInputDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'email': value['email'],
        'listingId': value['listingId'],
        'propertyMediaIds': value['propertyMediaIds'],
        'isBAndPInspectionRequired': value['isBAndPInspectionRequired'],
    };
}
